import React, { useState } from 'react'
import scanPhoto from '../../assets/scanPhoto.svg'
import iconLock from '../../assets/iconLock.svg'

interface props {
  handleClick: any
  isDocumentSent:boolean
} 
 
const PersonalInformationContainer: React.FC<props> = ({ handleClick, isDocumentSent }) => {
  const[onVerif, setOnVerif] = useState(false)
  
    return (
    <div className='flex flex-col items-center w-full lg:w-full sm:mt-5 '>
      <img src={scanPhoto} className="sm:w-[350px] w-[400px]" />
      <div className="text-[#1D3A70] text-[24px] font-bold text-center mt-5">Nous devons vérifier votre identité</div>
      <p className="text-[#6B7280] text-[15px] text-center">
        Afin de vérifier votre identité, nous acceptons les documents suivants :
        
      </p>
      <ul className='text-[#6B7280] py-4 text-[15px] list-inside list-disc '>
          <li>Carte d&apos;identité européenne</li>
          <li> Tous les passeports</li>
          <li> Titre de séjour</li>
        </ul>
      <p className="text-[#6B7280] text-[15px] sm:text-[14px] w-[600px]  lg:w-full text-center">
        Pour garantir la sécurité de la vérification, nous vous demanderons de filmer votre document 
        en quelques étapes rapides sur notre plateforme, en moins de 5 minutes.
      </p>
      <div className="flex items-center justify-around rounded-lg bg-[#5754E533] mt-5 p-5 maw-w-max">
        <img src={iconLock} />
        <div className="text-[#0C266C] font-semibold text-[15px] sm:text-[14px] pl-4">
          Nous prenons la sécurité de vos données très au sérieux. <br /> Elles ne seront utilisées qu&apos;à des fins
          de vérification.
        </div>
      </div>
      <div className="flex justify-center">
        <button
          type="submit"
          disabled={onVerif || isDocumentSent }
          onClick={()=>{handleClick(), setOnVerif(true) }}
          className={`text-white text-[16px] font-bold p-4 w-[400px] rounded-xl sm:w-[300px] sm:text-[14px] mt-8 
          ${onVerif || isDocumentSent ? 'bg-gray-400' : 'bg-[#4743C9]'}`}>
          
          {onVerif || isDocumentSent ?
          <svg
                    className="w-6 h-6 mx-auto animate-spin text-white "
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-50"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C6.477 0 2 4.477 2 10h2zm2 5.291A7.971 7.971 0 014 12H2c0 2.21.896 4.209 2.344 5.656l1.656-1.365z"
                    ></path>
          </svg>
          :
          'Vérifiez votre identité'
          }
        </button>
      </div>

      {/* {user?.user?.destinationDefaultCountry
      &&
      <Modal isOpen={openModalGuide} onClose={() => setOpenModalGuide(false)}>
        <div className='flex flex-col items-center'>
          <img className='mx-auto ' src={Alert} alt='message alert'/>
          <div className='text-[#FFF] text-[20px] font-medium text-center py-5'>
            Si vous avez un passeport tunisien,
            malheureusement il n&apos;est pas biométrique. Donc il faudra choisir le 
            Maroc ou l&apos;Algérie comme pays émetteur 
            pour pouvoir nous l&apos;envoyer.
            <br/> Merci de votre compréhension.
          </div>
        </div>

      </Modal>
      } */}
    </div>
  )
}

export default PersonalInformationContainer
